// One signal for "an approval request changed", shared by every screen that shows
// one: the maker's My Change Requests, the manager's review queue and the bell.
//
// Two sources feed it. A change made in this tab (a save held, an approve, a
// reject, a reason) announces itself at once, so the screen that acted never
// waits. A change made by somebody else is picked up by SupervisionPulse, which
// polls a cheap stamp and announces only when it moves.
import { useEffect, useRef } from 'react';

export const SUPERVISION_CHANGED_EVENT = 'supervisionChanged';
export const NOTIFICATIONS_REFRESH_EVENT = 'notificationsRefresh';

/** Tell every listening screen to re-read. `local` marks a change made in this tab. */
export function announceSupervisionChange(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUPERVISION_CHANGED_EVENT, { detail: { local: true, ...detail } }));
}

/** Run `callback` whenever an approval request changes, here or elsewhere. */
export function useSupervisionChanged(callback) {
  const ref = useRef(callback);
  useEffect(() => { ref.current = callback; }, [callback]);
  useEffect(() => {
    const handler = (event) => ref.current && ref.current(event?.detail || {});
    window.addEventListener(SUPERVISION_CHANGED_EVENT, handler);
    return () => window.removeEventListener(SUPERVISION_CHANGED_EVENT, handler);
  }, []);
}
